<div class="add-events-container">
    <div class="add-events-header">
        <!-- <p>Additional Events</p> -->
        <p>{{alertvarservice.titles.templateTitles.additional_events.additional_events}}</p>
        <img src="assets/alerts/close.svg" mat-dialog-close>
    </div>
    <div class="add-events-body">
        <div class="heading">
            <p>{{alertvarservice.titles.templateTitles.additional_events.event_time}}</p>
            <p>{{alertvarservice.titles.templateTitles.additional_events.event_details}}</p>
        </div>
        <div class="content">
            <ng-container *ngIf="data.additionallist.length" >
                <div *ngFor="let event of data.additionallist; index as i">
                    <div class="event-content">
                        <p class="alert-time"> {{event.event_TS | date : 'YYYY-MM-dd HH:mm:ss'}} </p>
                        <div class="list">
                            <p class="event-log-line">
                                <ng-container *ngFor="let field of event | keyvalue: originalOrder">
                                    <ng-container *ngIf="field | keyvalue :originalOrder">
                                        <a class="field-pairs" *ngIf="field.value">
                                            <span class="key">{{field.key | titlecase}} : </span>
                                            <span class="value">{{field.value}}</span>
                                        </a>
                                    </ng-container>
                                </ng-container>
                            </p>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>